import { computed, ref } from 'vue'
import {
  isWelcomeNotificationSnoozed,
  isWelcomeWizardComplete,
  markWelcomeWizardComplete,
  snoozeWelcomeNotification,
} from '@/helpers/dashboardWelcomeWizard'
import { useDashboardWelcome } from '@/composables/useDashboardWelcome'

const notificationSnoozed = ref(isWelcomeNotificationSnoozed())
const welcomeDismissed = ref(isWelcomeWizardComplete())

/** Persists dismissal and updates reactive visibility for the welcome notification. */
export function completeWelcomeNotification() {
  markWelcomeWizardComplete()
  welcomeDismissed.value = true
}

/**
 * Dashboard welcome notification visibility and dismissal.
 * Shown on the first dashboard visit (`dashboardSeen === false` on load).
 * The nav tour is started separately via `useDashboardNavTour`.
 */
export function useDashboardWelcomeWizard() {
  const { isWelcomeReady, isFirstDashboardVisit } = useDashboardWelcome()

  const showWelcomeNotification = computed(
    () =>
      isWelcomeReady.value &&
      isFirstDashboardVisit.value &&
      !welcomeDismissed.value &&
      !notificationSnoozed.value
  )

  const snoozeWelcomeNotificationForSession = () => {
    snoozeWelcomeNotification()
    notificationSnoozed.value = true
  }

  const dismissWelcomePermanently = () => {
    completeWelcomeNotification()
  }

  return {
    showWelcomeNotification,
    snoozeWelcomeNotificationForSession,
    dismissWelcomePermanently,
  }
}
